/** Rendering pre-processor service, that stores collection of {@link UIPRenderingPreprocessor}s */
export class UIPPreprocessorService {
    constructor() {
        /** Pre-processor storage */
        this.preprocessors = {};
    }
    /** Add pre-processor {@link UIPRenderingPreprocessor} */
    add(name, preprocessor) {
        this.preprocessors[name] = preprocessor;
    }
    /** Add pre-processor alias */
    addAlias(name, alias) {
        this.preprocessors[name] = this.preprocessors[alias];
    }
    addRegexReplacer(name, regex, replacer) {
        this.add(name, (input) => input.replace(regex, replacer));
    }
    get(name) {
        return this.preprocessors[name];
    }
    /** Pre-process html content */
    preprocess(html) {
        return Object.keys(this.preprocessors)
            .map((name) => this.preprocessors[name])
            .filter((preprocessor) => typeof preprocessor === 'function')
            .reduce((input, preprocessor) => preprocessor(input), html);
    }
    /** Clear all pre-processors */
    clear() {
        this.preprocessors = {};
    }
}
